export const canRenderRouterView = ({ tenantSetting, branchContextReady }) => (
  !!tenantSetting && branchContextReady
);
